export default "__VITE_ASSET__lCMiynLv__"